import React, {useEffect, useRef, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import AdyenCheckout from "@adyen/adyen-web";
import {useDispatch} from "react-redux";

import styles from './CheckoutResult.module.scss';
import successImg from '../../assets/images/checkout_success.png';
import errorImg from '../../assets/images/error.png';

import {ADYEN_CLIENT_KEY, ENV_ADYEN} from "../../shared/constants";
import ButtonMain from "../../components/buttons/ButtonMain/ButtonMain";
import {clearSelectedOffer} from "../../redux/rootReducer";
import {getQueryParams} from "../../shared/helpers";

const CheckoutResult = ({ config }) => {
    let isFirstPageView = useRef(true);
    const navigate = useNavigate();
    const { state } = useLocation();
    const dispatch = useDispatch();
    const [isNoStateCase, setIsNoStateCase] = useState(false);

    const unselectOffer = () => {
        dispatch(clearSelectedOffer());
    };

    useEffect(() => {
        if (!state && !isNoStateCase) {
            setTimeout(() => {
                setIsNoStateCase(true);
            }, 1500);
        }
    }, []);

    useEffect(() => {
        const hash = window.location.search;
        if (hash) {
            const params = getQueryParams(hash);
            const initAdyen = async () => {
                const configuration = {
                    environment: ENV_ADYEN, // Change to 'live' for the live environment.
                    clientKey: ADYEN_CLIENT_KEY, // Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
                    session: {
                        id: params.sessionId
                    },
                    onPaymentCompleted: (result, component) => {
                        dispatch(clearSelectedOffer());
                        if (result.resultCode == 'Authorised') {
                            navigate('/checkout-result', {state: {success: true, transactionId: params.intentionId}});
                        } else {
                            navigate('/checkout-result', {state: {success: false}});
                        }
                    },
                    onError: (error, component) => {
                        dispatch(clearSelectedOffer());
                        navigate('/checkout-result', {state: {success: false}});
                    },
                    // Any payment method specific configuration. Find the configuration specific to each payment method:  https://docs.adyen.com/payment-methods
                    // For example, this is 3D Secure configuration for cards:
                    paymentMethodsConfiguration: {
                        card: {
                            hasHolderName: true,
                            holderNameRequired: true,
                        }
                    }
                };
                const checkout = await AdyenCheckout(configuration);
                checkout.submitDetails({ details: { redirectResult: params.redirectResult } });
            }

            initAdyen();
        }
    }, [window.location]);

    useEffect(() => {
        if (isFirstPageView.current) {
            const gaPath = (state && state.success) ? 'completed' : 'failed';
            window.gtag('event', 'screen_view', {
                'app_name': 'teamtop shop',
                'screen_name': gaPath
            });
            window.gtag('event', 'page_view', {
                'app_name': 'teamtop shop',
                'page_title': gaPath
            });
            isFirstPageView.current = false;
        }
    }, []);

    return (
        state ?
            <div className={styles.backgroundAddOn}>
                <div className={styles.wrapper}>
                    <div className={styles.result}>
                        <img
                            className={`${styles.img} ${state.success ? styles.successImg : styles.errorImg}`}
                            src={state.success ? successImg : errorImg}
                            alt={''}
                        />
                        <div className={styles.info}>
                            {state.success ?
                                state.isGeneric ?
                                    <div className={styles.resultInfo}>
                                        <div className={styles.title}>
                                            <span>{config.checkoutResult.genericTitle}</span>
                                            <span>{state.transactionId}</span>
                                        </div>
                                        <div className={styles.text}>
                                            <p>
                                                {config.checkoutResult.genericText1}
                                            </p>
                                            <p>
                                                {config.checkoutResult.genericText2}
                                            </p>
                                            <p>
                                                {config.checkoutResult.genericText3}
                                            </p>
                                            <p>
                                                <a
                                                    target={'_blank'}
                                                    rel="noreferrer"
                                                    href={'http://6waves.jp/support/'}
                                                >
                                                    http://6waves.jp/support/
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                    :
                                    <div className={styles.resultInfo}>
                                        <div className={styles.title}>
                                            {config.checkoutResult.successTitle}
                                        </div>
                                        <div className={styles.title}>
                                            <span>{config.checkoutResult.transactionId}</span>
                                            <span>{state.transactionId}</span>
                                        </div>
                                        <div className={styles.text}>
                                            <p>
                                                {config.checkoutResult.successInfo_1}
                                            </p>
                                            <p>
                                                {config.checkoutResult.successInfo_2}
                                            </p>
                                            <p>
                                                {config.checkoutResult.successInfo_3}
                                            </p>
                                            <p>
                                                {config.checkoutResult.successInfo2_1}
                                            </p>
                                            <p>
                                                {config.checkoutResult.successInfo2_2}
                                            </p>
                                            <p>
                                                {config.checkoutResult.successInfo2_3}
                                            </p>
                                        </div>
                                    </div>
                                :
                                <div className={styles.resultInfo}>
                                    <div className={styles.title}>
                                        {config.checkoutResult.errorTitle}
                                    </div>
                                    <div className={styles.text}>
                                        <p>
                                            {config.checkoutResult.errorInfo}
                                        </p>
                                        <p><a target={'_blank'}
                                              href={'http://6waves.jp/support/'}>http://6waves.jp/support/</a></p>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className={styles.backToShop}>
                        <ButtonMain
                            text={config.backToShop}
                            onClick={() => {
                                unselectOffer();
                                navigate('/shop');
                            }}
                            isNegative={state.success ? null : true}
                            isBig={true}
                        />
                    </div>
                </div>
            </div>
            :
            <div className={styles.noStateWrapper}>
                {isNoStateCase ?
                    <div className={styles.noProductsGeneral}>{config.noProducts}</div>
                    :
                    null
                }
            </div>
    );
};
export default CheckoutResult;